import { useEffect } from 'react';

import { useRecoilValue, useSetRecoilState } from 'recoil';

import state from '../state';

export const useMarkKioskSaleArmed = (isArmed) => {
  const setSaleArmed = useSetRecoilState(state.saleArmedState);

  useEffect(() => {
    if (!isArmed) return undefined;
    setSaleArmed(true);
    return () => setSaleArmed(false);
  }, [isArmed, setSaleArmed]);
};

export const useIsKioskSaleArmed = () => useRecoilValue(state.saleArmedState);
